import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UtilService } from './util.service';
import { EntradaConsultaErro, SaidaConsultaErro } from '@models/Erro';

@Injectable({ providedIn: 'root' })
export class ErroService {

  constructor(private http: HttpClient, private utilService: UtilService) { }

  ConsultaErros(codigo: number): Observable<SaidaConsultaErro> {
    const entrada: EntradaConsultaErro = {
      codigo: codigo,
      ticketUsuario: localStorage.getItem('ticketUsuario')
    };
    const url = `${this.utilService.funcaoObterURLAPI()}/erro/consultar`;
    return this.http.post<SaidaConsultaErro>(url, entrada).pipe(
      map(obj => obj),
      catchError(e => this.errorHandler(e))
    );
  }

  errorHandler(e: any): Observable<any> {
    //console.log(e);
    //this.shorMessage('Ocorreu um erro!', true);
    //return EMPTY;
    return e;
  }
}
